import React, { Component } from 'react';
import {
  View,
} from 'react-native';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import { Button, ButtonTypes, Heading, HeadingTypes } from '../components';
import Theme from '../theme';
import { showMessage, TextInput } from '../ui/components';
import { UserDataConsumer } from '../utils';
import {
  isRequired,
} from '../utils/validator';
import { Logger } from '../utils/Logger';

const styles = {
  container: {
    padding: 20,
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  heading: {
    fontSize: 18,
    // fontWeight: '900',
    fontFamily: Theme.Custom800,
    paddingVertical: 10,
    textAlign: 'center',
    color: Theme.CHARCOAL,
  },
};

class QuestionScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      values: {
      },
    };
  }

  render() {
    return (
      <View
        style={styles.container}>

        <Heading
          title={'Ask us a question or give us your feedback'}
          headingType={HeadingTypes.HEADING_TWO}
          style={styles.heading}
        />

        <Field
          forwardRef
          name='feedback'
          component={TextInput}
          autoCapitalize='none'
          placeholder='Feedback'
          keyboardType='default'
          returnKeyType='done'
          onChange={(feedback) => this.setFormValues({ feedback })}
          validate={isRequired}
          ref={(ref) => { this.feedback = ref; }}
        />

        <Button
          fontColor={Theme.WHITE}
          disabled={this.state.submitting || !this.state.values.feedback}
          onPress={this.onSubmit}
          title='Send'
          isLoading={this.state.submitting}
        />

        <Button
          onPress={() => this.props.navigation.goBack(null)}
          title='Cancel'
          containerStyle={{ marginVertical: 5 }}
          buttonType={ButtonTypes.TRANSPARENT}
        />

      </View>
    );
  }

  setFormValues = (value) => {
    this.setState({
      values: {
        ...this.state.values,
        ...value,
      },
    });
  }

  onSubmit = () => {
    const { feedback } = this.state.values;
    console.log('[feedback]', feedback);

    this.setState({
      submitting: true,
    });

    Logger.notify(new Error(feedback), (report) => {
      report.errorClass = 'User feedback/question';
      report.errorMessage = feedback;
    });
    showMessage('Feedback/question reported');
    this.props.navigation.goBack(null);
  }
}

QuestionScreen = UserDataConsumer(QuestionScreen);
QuestionScreen = translate(['home'], { wait: true })(QuestionScreen);
QuestionScreen = reduxForm({ form: 'QuestionForm' })(QuestionScreen);
export default QuestionScreen;
